import { render, staticRenderFns } from "./LastPageLink.vue?vue&type=template&id=4a82a6c3&"
import script from "./LastPageLink.vue?vue&type=script&lang=js&"
export * from "./LastPageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports